<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import 'src/styles/global.scss';
@import 'src/styles/sqr.scss';
</style>

<style>
#app {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: auto;
  margin-bottom: 30px;
  max-width: 984px;
  min-width: 320px;
  min-height: 700px;
}
@media print{
  #app {
    width: 984px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue